/* @flow */

import React from 'react';
import { Card, Input } from 'semantic-ui-react';
import Image from './items/Image';
import Pdf from './items/Pdf';
import Video from './items/Video';
import { ResourceTypes } from 'bucket/constants';
import ConfirmDeleteButton from 'shared/components/ConfirmDeleteButton';

type Props = {
  resources: Array<BucketResource>,
  resource: BucketResource,
  onUpdate: (resource: BucketResource) => void,
  onCrop: (resource: BucketResource, conf: CropConfig) => void,
  onRemove: (resource: BucketResource) => void,
  isRemoving: boolean,
};

const ResourceItem = ({
  resources,
  resource,
  onUpdate,
  onRemove,
  isRemoving,
  onCrop,
}: Props) => {
  const nameChanged = (_, { value }) =>
    onUpdate({
      ...resource,
      name: value,
    });

  const remove = () => onRemove(resource);

  const renderContent = () => {
    switch (resource.type.category) {
      case ResourceTypes.IMAGE:
        return (
          <Image resource={resource} resources={resources} onCrop={onCrop} />
        );
      case ResourceTypes.PDF:
        return <Pdf resource={resource} />;
      case ResourceTypes.VIDEO:
        return <Video resource={resource} />;
      default:
        console.warn(`Unknown resource category ${resource.type.category}`);
        return null;
    }
  };

  const deleteModalContent = `
    Êtes-vous sûre de vouloir supprimer cette ressource ?
  `;

  return (
    <Card>
      <Card.Content extra>
        <Input fluid value={resource.name} onChange={nameChanged} />
      </Card.Content>
      {renderContent()}
      <Card.Content extra>
        <ConfirmDeleteButton
          content="Supprimer"
          modalContent={deleteModalContent}
          isLoading={isRemoving}
          className="basic fluid red"
          onConfirm={remove}
        />
      </Card.Content>
    </Card>
  );
};

export default ResourceItem;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/ResourceItem.js